import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles((theme) => ({
  summary: {
    cursor: "default !important",
    height: "100%",
    flexDirection: "row-reverse",
    padding: theme.spacing(1, 2),
    backgroundColor:
      theme.palette.programingOnDemandGrouped.subModule.backgroundColor,
    color: theme.palette.programingOnDemandGrouped.subModule.color,
    "&[aria-expanded=true]": {
      height: "auto",
    },
  },
  details: {
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    flexDirection: "column",
    backgroundColor:
      theme.palette.programingOnDemandGrouped.session.backgroundColor,
    color: theme.palette.programingOnDemandGrouped.session.color,
  },
  titleContainer: {
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
    lineHeight: "1.5 !important",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "center",
    },
  },
  title: {
    flex: 1,
  },
  detailInfo: {
    [theme.breakpoints.down("sm")]: {
      alignSelf: "flex-end",
    },
  },
}));
